var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2875 4.5015H6.825V3.957C6.825 3.039 6.573 1.503 4.875 1.503C3.112 1.503 2.925 3.2175 2.925 3.957V4.5015H1.4625V3.957C1.4625 1.552 2.803 0 4.875 0C6.947 0 8.2875 1.552 8.2875 3.957V4.5015ZM5.85 8.4985C5.85 7.946 5.411 7.50001 4.875 7.50001C4.339 7.50001 3.9 7.946 3.9 8.4985C3.9 8.8725 4.09551 9.19001 4.38801 9.35949V10.4975C4.38801 10.7735 4.607 11.0015 4.87551 11.0015C5.14401 11.0015 5.36301 10.7735 5.36301 10.4975V9.35949C5.655 9.19001 5.85 8.8725 5.85 8.4985ZM9.75 6.5V11.497C9.75 12.3255 9.09149 13 8.2875 13H1.4625C0.659001 13 0 12.3255 0 11.497V6.5C0 5.67201 0.658506 4.997 1.4625 4.997H8.2875C9.09149 4.997 9.75 5.67201 9.75 6.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIcon);
export default __webpack_public_path__ + "static/media/password_icon.714ca80c46b620f5a91e77445c3f604c.svg";
export { ForwardRef as ReactComponent };